import { QuestionnaireTemplatePostRequest } from '@/dtos/questionnaires/templates/post'

export class QuestionnaireTemplateDraftPostRequest extends QuestionnaireTemplatePostRequest {}
